import { pageHead } from "@app/framework/meta";
import { KeyFiguresPage } from "@modules/investor-relations/pages";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function KeyFigures() {
  useLoaderData();

  return <KeyFiguresPage />;
}

export const meta: MetaFunction = () =>
  pageHead({
    title: trans("keyFigures"),
    appendAppName: true,
  });
